const quotationChat = {
  quotationChatNavLabel: "Chat de presupuesto", // translated 
  quotationChatApprovalTitle: "Chat de presupuesto", // translated 
  quotationChatAccountNotApprovedTitle: "Cuenta no aprobada", // translated 
  quotationChatAccountNotApprovedDescription:
    "Su cuenta aún no está aprobada. Póngase en contacto con su gestor de cuenta para más información.", // translated 
  quotationChatViewAiChat: "Ver chat de I.A.", // translated 

  quotationRequestChatSessions: "Sesiones de chat", // translated 
  quotationRequestChatNoPastSessions: "No hay sesiones anteriores", // translated 
  quotationRequestChatNewChat: "Nuevo chat", // translated 
  quotationRequestChatCloseSidebar: "Cerrar barra lateral", // translated 
  quotationRequestChatSessionFallback: "Sesión de chat", // translated 
  quotationRequestChatDefaultSessionName: "Nueva sesión de chat", // translated 
  quotationRequestChatTitle: "Chat de solicitud de presupuesto", // translated 
  quotationRequestChatResponseLanguageLabel: "Idioma de respuesta", // translated 
  quotationRequestChatOpenSidebar: "Abrir barra lateral", // translated 
  quotationRequestChatRenameSession: "Renombrar sesión", // translated 
  quotationRequestChatDeleteSession: "Eliminar sesión", // translated 
  quotationRequestChatToggleDarkMode: "Alternar modo oscuro", // translated 
  quotationRequestChatSwitchToLightMode: "Cambiar a modo claro", // translated 
  quotationRequestChatSwitchToDarkMode: "Cambiar a modo oscuro", // translated 
  quotationRequestChatEmptyStateHeading: "Iniciar una nueva conversación de solicitud de presupuesto", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Describa sus necesidades de viaje y crearé una solicitud de presupuesto para usted.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Escriba su mensaje para iniciar una conversación... (Mayús+Intro para nueva línea)", // translated 
  quotationRequestChatMessagePlaceholder: "Escriba su mensaje... (Mayús+Intro para nueva línea)", // translated 
  quotationRequestChatUploadFile: "Subir archivo", // translated 
  quotationRequestChatUploadAttachment: "Subir adjunto", // translated 

  quotationRequestChatStopGenerating: "Detener generación", // translated 
  quotationRequestChatGenerateQuotation: "Generar presupuesto", // translated 
  quotationRequestChatGenerateFinalQuotation: "Generar presupuesto final", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Finalizar solicitud de presupuesto", // translated 
  quotationRequestChatHoldToRecord: "Mantenga pulsado para grabar mensaje de voz.", // translated 
  quotationRequestChatRecordingReleaseToSend: "Grabando, suelte para enviar", // translated 
  quotationRequestChatRecording: "Grabando...", // translated 
  quotationRequestChatSelectSessionFirst: "Selecciona primero una sesión de chat.", // translated 
  quotationRequestChatCancelVoiceRecording: "Cancelar grabación de voz", // translated 
  quotationRequestChatListening: "Escuchando...", // translated 
  quotationRequestChatTranscribing: "Transcribiendo...", // translated 

  quotationRequestChatFileUploadedSuccess: "Archivo subido correctamente.", // translated 
  quotationRequestChatFailedCreateSession: "No se pudo crear la sesión de chat. Inténtelo de nuevo.", // translated 
  quotationRequestChatFailedUploadFile: "No se pudo subir el archivo. Inténtelo de nuevo.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Responda las preguntas pendientes antes de enviar otro mensaje.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Responda las preguntas pendientes antes de finalizar la solicitud de presupuesto.", // translated 
  quotationRequestChatFavoriteMarked: "Sesión de chat marcada como favorita", // translated 
  quotationRequestChatFavoriteUnmarked: "Sesión de chat eliminada de favoritos", // translated 
  quotationRequestChatFailedSetFavorite: "No se pudo marcar como favorito", // translated 
  quotationRequestChatFailedUnsetFavorite: "No se pudo quitar de favoritos", // translated 
  quotationRequestChatRenamedSuccess: "Sesión de chat renombrada correctamente.", // translated 
  quotationRequestChatFailedRename: "No se pudo renombrar la sesión de chat. Inténtelo de nuevo.", // translated 
  quotationRequestChatDeletedSuccess: "Sesión de chat eliminada correctamente.", // translated 
  quotationRequestChatFailedDelete: "No se pudo eliminar la sesión de chat. Inténtelo de nuevo.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Adjunto eliminado correctamente.", // translated 
  quotationRequestChatFailedDeleteAttachment: "No se pudo eliminar el adjunto. Inténtelo de nuevo.", // translated 
  quotationRequestChatSubmittedSuccess:
    "¡Solicitud de presupuesto enviada correctamente! Su solicitud se está procesando.", // translated 
  quotationRequestChatFailedSubmit: "No se pudo enviar la solicitud de presupuesto", // translated 
  quotationChatPdfDownloadedSuccess: "¡PDF descargado correctamente!", // translated 
  quotationChatFailedGeneratePdf: "No se pudo generar el PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Seleccione un usuario subagente antes de enviar la solicitud de presupuesto.", // translated 
  quotationRequestChatAppUserLoading:
    "Su perfil de usuario de la aplicación CRM aún se está cargando. Inténtelo de nuevo en un momento.", // translated 
  quotationRequestChatAppUserMismatch:
    "Su perfil de usuario de la aplicación CRM no coincide con esta sesión de chat.", // translated 

  quotationRequestChatRenameTitle: "Renombrar sesión de chat", // translated 
  quotationRequestChatSessionName: "Nombre de la sesión", // translated 
  quotationRequestChatEnterSessionName: "Introduzca el nombre de la sesión", // translated 
  quotationRequestChatSaving: "Guardando...", // translated 
  quotationRequestChatSave: "Guardar", // translated 
  quotationRequestChatDeleteTitle: "Eliminar sesión de chat", // translated 
  quotationRequestChatDeleteConfirm: "¿Está seguro de que desea eliminar esta sesión de chat?", // translated 
  quotationRequestChatDeleteCannotUndo: "Esta acción no se puede deshacer.", // translated 
  quotationRequestChatDeleting: "Eliminando...", // translated 
  quotationRequestChatDelete: "Eliminar", // translated 

  quotationRequestChatAttachmentsTitle: "Adjuntos del chat de solicitud de presupuesto", // translated 
  quotationRequestChatLoadingAttachments: "Cargando adjuntos...", // translated 
  quotationRequestChatNoAttachments: "No se encontraron adjuntos", // translated 
  quotationRequestChatDeleteAttachment: "Eliminar adjunto", // translated 
  quotationRequestChatUploadingAttachment: "Subiendo adjunto...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Espere mientras se sube su archivo.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Responder preguntas pendientes", // translated 
  quotationRequestChatProposeOwnAnswer: "Proponer mi propia respuesta", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Escriba su propia respuesta...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{answered}} de {{total}} respondidas", // translated 
  quotationRequestChatReadyToSubmit: "Listo para enviar", // translated 
  quotationRequestChatSubmitAll: "Enviar todo", // translated 
  quotationRequestChatRespondToOneQuestion: "Responder a {{count}} pregunta", // translated 
  quotationRequestChatRespondToManyQuestions: "Responder a {{count}} preguntas", // translated 

  quotationRequestChatFinalizeTitle: "Finalizar solicitud de presupuesto", // translated 
  quotationRequestChatLoadingSessionData: "Cargando datos de la sesión...", // translated 
  quotationRequestChatErrorLoadingSession: "Error al cargar los datos de la sesión. Inténtelo de nuevo.", // translated 
  quotationRequestChatQuotationTitle: "Título del presupuesto", // translated 
  quotationRequestChatExtraComments: "Comentarios adicionales", // translated 
  quotationRequestChatSubmitting: "Enviando...", // translated 
  quotationRequestChatSubmit: "Enviar", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Enviando solicitud de presupuesto...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Espere mientras se envía su solicitud de presupuesto.", // translated 

  quotationRequestChatSelectSubagent: "Seleccionar subagente", // translated 
  quotationRequestChatSearchSubagents: "Buscar subagentes...", // translated 
  quotationRequestChatLoadingSubagents: "Cargando subagentes...", // translated 
  quotationRequestChatNoSubagentsFound: "No se encontraron subagentes", // translated 
  quotationRequestChatNoSubagentsAvailable: "No hay subagentes disponibles", // translated 
  quotationRequestChatSelectedSubagent: "Seleccionado: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Usuarios subagente", // translated 
  quotationRequestChatSearchUsers: "Buscar usuarios...", // translated 
  quotationRequestChatNoUsersFound: "No se encontraron usuarios", // translated 
  quotationRequestChatNoUsersAvailable: "No hay usuarios disponibles", // translated 

  quotationChatDownloadSummaryTitle: "Descargar el resumen de su presupuesto", // translated 
  quotationChatDownloadSummaryDescription:
    "Complete sus datos a continuación para generar un resumen PDF personalizado de su presupuesto de viaje. El PDF incluye todos los detalles del viaje, destinos, información de transporte e itinerario día a día.", // translated 
  quotationChatCustomerTitle: "Tratamiento", // translated 
  quotationChatSelectTitle: "seleccionar tratamiento", // translated 
  quotationChatHonorificMr: "Sr.", // translated 
  quotationChatHonorificMrs: "Sra.", // translated 
  quotationChatHonorificMs: "Srta.", // translated 
  quotationChatHonorificDr: "Dr.", // translated 
  quotationChatHonorificProf: "Profe.", // translated 
  quotationChatCustomerPhone: "Teléfono", // translated 
  quotationChatCustomerCompany: "Empresa", // translated 
  quotationChatCustomerMessage: "Mensaje", // translated 
  quotationChatCustomerCountry: "País", // translated 
  quotationChatGenerating: "Generando...", // translated 
  quotationChatDownloadPdf: "Descargar PDF", // translated 

  quotationChatTripSummary: "Resumen del viaje", // translated 
  quotationChatDownloadAsPdf: "Descargar como PDF", // translated 
  quotationChatNoTripSummary: "No hay resumen de viaje disponible para esta sesión.", // translated 

  quotationRequestChatThinking: "Pensando...", // translated 
  quotationRequestChatSources: "Fuentes", // translated 
  quotationRequestChatSearchingWebFor: 'Buscando en la web: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Servicios ejecutados por el touroperador", // translated 
  quotationRequestChatServicesByCustomer: "Servicios gestionados por el cliente.", // translated 
  quotationRequestChatReadyNotice:
    "Ya puedes generar un presupuesto para esta solicitud haciendo clic en el botón de la derecha.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Generar presupuesto final", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Quizás quiera preguntar:", // translated 
  quotationRequestChatClickToSendSuggestion: "Haga clic para enviar este mensaje", // translated 

  quotationRequestChatAddToFavorites: "Agregar a favoritos", // translated 
  quotationRequestChatRemoveFromFavorites: "Quitar de favoritos", // translated 
  quotationRequestChatSubmitted: "Enviado", // translated 

  quotationRequestChatQuotationRequest: "Solicitud de presupuesto: {{referencia}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{título}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Estado: {{status}}", // translated 

  quotationChatLoading: "Cargando...", // translated 
  quotationChatSessionNotFound: "No se encontró sesión de chat para este presupuesto.", // translated 
  quotationChatMemberSessionNotFound: "No se encontró sesión de miembro para su cuenta", // translated 
  quotationChatUnableToConnect: "No se puede conectar al chat", // translated 
  quotationChatConnecting: "Conectando...", // translated 
  quotationChatTypeYourMessage: "escriba su mensaje...", // translated 
  quotationChatConnected: "Conectado", // translated 
  quotationChatConnectingStatus: "Conectando...", // translated 
  quotationChatDisconnected: "Desconectado", // translated 
};


export default quotationChat;
